module.exports = __webpack_public_path__ + "f77d191b04e1189c5e21572607b58910.fbx";